// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MCXA","newExpiryDate":"styles_newExpiryDate__qVaDa","footer":"styles_footer__tWrLH"};